import { Paths } from '../../../lib/constants/path'
import { RoleEnum } from '../../../lib/types/enums/users/role.enum'
import { Route } from '../../../lib/types/routes'
import PeriodsPage from './periods'

const periodRoutes: Route[] = [
  {
    path: Paths.SETTING_PERIODS,
    element: <PeriodsPage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default periodRoutes
